<template>
  <fieldset>
    <legend class="col-lg-offset-1 col-lg-10">
      <span v-t="'TARGET_DUPLICATE_SETTINGS_TITLE'" />
      <a
        v-tooltip.right="$t('TARGET_DUPLICATE_SETTINGS_TITLE_TT')"
        class="m-l-10 f-s-16"
      >
        &nbsp;&nbsp;<i class="fa fa-question-circle" />
      </a>
    </legend>

    <div class="form-group">
      <Field
        :label="$t('DUPLICATE_SETTINGS_OPTIONS')"
        :hide-label="false"
        :has-tooltip="true"
        :tooltip-text="$t('DUPLICATE_SETTINGS_OPTIONS_TT')"
      >
        <template #element>
          <div class="col-sm-5 col-md-5">
            <ValidationProvider
              rules="required"
              slim
            >
              <SearchableDropdown
                :value="dupeSettingOptionSelected"
                name="dupeRestrictOption"
                class="m-b-10"
                :config="dupeSettingsSelectConfig"
                :clearable="false"
                :disabled="disabled"
                @change="onDupeSettingChange"
              />
            </ValidationProvider>
          </div>
        </template>
      </Field>
      <div v-if="showOverrideSettings">
        <Field
          :label="$t('RESTRICT_ON')"
          :hide-label="false"
          :has-tooltip="true"
          :tooltip-text="$t('RESTRICT_ON_TT')"
        >
          <template #element>
            <ValidationProvider
              v-slot="{ classes }"
              rules="required"
              slim
            >
              <div class="col-sm-4 col-md-3">
                <SearchableDropdown
                  v-model="dupeSettingSelected.previousCallState"
                  name="conversionType"
                  class="m-b-10"
                  :config="conversionTypeDropdownConfig"
                  :clearable="false"
                  :disabled="disabled"
                  @change="onPayoutOnDropdownOnChange"
                />
              </div>
            </ValidationProvider>
          </template>
        </Field>
        <Field
          :label="$t('DUPLICATE_RESTRICTION_DURATION')"
          :hide-label="false"
          :has-tooltip="true"
          :tooltip-text="$t('DUPLICATE_RESTRICTION_DURATION_TT')"
        >
          <template #element>
            <div class="col-sm-6 col-md-6">
              <ValidationProvider
                rules="required"
                slim
              >
                <MultipleToggle
                  :value="dupeRestrictOptionSelected"
                  :options="dupeRestrictToggleOptions"
                  :disabled="disabled"
                  @onToggle="onDupeRestrictOptionsChange"
                >
                  <template>
                    <div
                      v-if="dupeRestrictOptionSelected == 1"
                      class="m-t-5"
                    >
                      <ValidationProvider
                        rules="required"
                        slim
                      >
                        <input
                          v-model.lazy="daysFromLastCall"
                          class="form-control days-input"
                          type="number"
                          min="1"
                          :disabled="disabled"
                          oninput="validity.valid||(value='')"
                          @change="onDaysFromLastCallChange"
                        >
                      </ValidationProvider>
                      <label class="">{{
                        daysFromLastCall > 1 ? 'Days' : 'Day'
                      }}</label>
                    </div>
                  </template>
                </MultipleToggle>
              </ValidationProvider>
            </div>
          </template>
        </Field>
      </div>
      <div v-if="showBuyerSettings">
        <Field
          :label="$t('RESTRICT_ON')"
          :hide-label="false"
          :has-tooltip="true"
          :tooltip-text="$t('RESTRICT_ON_TT')"
        >
          <template #element>
            <div class="col-sm-4 col-md-3">
              <label class="control-label">{{ buyerDuplicateSettings.previousCallState }}</label>
            </div>
          </template>
        </Field>
        <Field
          :label="$t('DUPLICATE_RESTRICTION_DURATION')"
          :hide-label="false"
          :has-tooltip="true"
          :tooltip-text="$t('DUPLICATE_RESTRICTION_DURATION_TT')"
        >
          <template #element>
            <div class="col-sm-6 col-md-6">
              <label class="control-label">{{ buyerRestrictionDuration }}</label>
            </div>
          </template>
        </Field>
      </div>
    </div>
  </fieldset>
</template>

<script>
import messages from '../locales';

import SectionHeader from '@/core/components/SectionHeader/SectionHeader';
import Field from '@/core/components/LabelAndElement/LabelAndElement';
import MultipleToggle from '@/core/components/MultipleToggle/MultipleToggle';
import SearchableDropdown from '@/core/components/SearchableDropdown/SearchableDropdown';


export default {
  components: { SectionHeader, Field, MultipleToggle, SearchableDropdown },
  props: {
    routeDuplicateSettings: {
      type: Object,
      default() {
        return  null;
      },
    },
    buyerDuplicateSettings: {
      type: Object,
      default() {
        return  null;
      },
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data: function () {
    return {
      dupeRestrictToggleOptions: Object.freeze([
        { name: 'Always', value: -1 },
        { name: 'Time Limit', value: 1 },
      ]),
      conversionTypeDropdownConfig: Object.freeze({
        options: ['Converted', 'Connected'],
        placeholder: 'Choose Type',
      }),
      dupeSettingSelected: this.routeDuplicateSettings,
    };
  },
  computed: {
    dupeSettingsSelectConfig() { return{
      options: [
        {
          label:
            this.$t('MULTIPLE_TOGGLE_OPTIONS_BUYER_SETTINGS') +
            ' (' +
            (this.buyerLabel) +
            ')',
          value: 'BuyerSettings',
        },
        {
          label: this.$t('MULTIPLE_TOGGLE_OPTIONS_NO_RESTRICT'),
          value: 'NoRestrict',
        },
        {
          label: this.$t('MULTIPLE_TOGGLE_OPTIONS_CAMPIGN_TARGET'),
          value: 'ByCampaignAndTarget',
        },
      ],
      reduce: option => option.value,
    };},
    dupeSettingOptionSelected() {
      if (!this.dupeSettingSelected) {
        return 'BuyerSettings';
      }
      if (this.dupeSettingSelected.bypassBuyerPolicy && this.dupeSettingSelected.allowDuplicatesAfter === 0) {
        return 'NoRestrict';
      }
      return 'ByCampaignAndTarget';
    },
    dupeRestrictOptionSelected() {
      return this.dupeSettingSelected.allowDuplicatesAfter < 1? this.dupeSettingSelected.allowDuplicatesAfter: 1;
    },
    buyerRestrictionDuration() {
      if (this.buyerDuplicateSettings.allowDuplicatesAfter === -1) {
        return 'Always';
      }
      return this.buyerDuplicateSettings.allowDuplicatesAfter + ' ' + (this.buyerDuplicateSettings.allowDuplicatesAfter > 1 ? 'Days' : 'Day');
    },
    daysFromLastCall: {
      get: function () {
        return this.dupeSettingSelected.allowDuplicatesAfter > 0
          ? this.dupeSettingSelected.allowDuplicatesAfter
          : 1;
      },
      set: function (val) {
        if (!val || val < 1) {
          val = '1';
        }
        this.dupeSettingSelected.allowDuplicatesAfter = val;
      },
    },
    showOverrideSettings() {
      return this.dupeSettingOptionSelected == 'ByCampaignAndTarget' ;
    },
    showBuyerSettings() {
      return this.dupeSettingOptionSelected == 'BuyerSettings' && this.buyerDuplicateSettings ;
    },
    buyerLabel() {
      let buyerlabelValue = this.$t('MULTIPLE_TOGGLE_OPTIONS_NO_RESTRICT');
      if (this.buyerDuplicateSettings && this.buyerDuplicateSettings.trackBy === 'Target') {
        buyerlabelValue = this.$t('MULTIPLE_TOGGLE_OPTIONS_CAMPIGN_TARGET');
      }
      if (this.buyerDuplicateSettings && this.buyerDuplicateSettings.trackBy === 'Buyer') {
        buyerlabelValue = this.$t('MULTIPLE_TOGGLE_OPTIONS_CAMPIGN');
      }
      return buyerlabelValue;
    }
  },
  watch: {
    routeDuplicateSettings() {
      this.dupeSettingSelected = this.routeDuplicateSettings;
    },
  },
  methods: {
    onDupeSettingChange(option) {
      switch (option) {
      case 'NoRestrict': {
        this.dupeSettingSelected = {
          bypassBuyerPolicy: true,
          allowDuplicatesAfter: 0,
          previousCallState: 'Converted',
        };
        break;
      }
      case 'BuyerSettings': {
        this.dupeSettingSelected = null;
        break;
      }
      case 'ByCampaignAndTarget': {
        this.dupeSettingSelected = {
          bypassBuyerPolicy: true,
          allowDuplicatesAfter: -1,
          previousCallState: 'Converted',
        };
        break;
      }
      }
      this.$emit('duplicateSettingsChange', this.dupeSettingSelected);
    },
    onDupeRestrictOptionsChange(option) {
      this.dupeSettingSelected.allowDuplicatesAfter = option.value;
      this.$emit('duplicateSettingsChange', this.dupeSettingSelected);
    },
    onPayoutOnDropdownOnChange(val) {
      this.dupeSettingSelected.previousCallState = val;
      this.$emit('duplicateSettingsChange', this.dupeSettingSelected);
    },
    onDaysFromLastCallChange(val) {
      this.dupeSettingSelected.allowDuplicatesAfter = this.daysFromLastCall;
      this.$emit('duplicateSettingsChange', this.dupeSettingSelected);
    }
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>

<style>
.days-input {
  width: 30%;
}
</style>